import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RequireAuth, RequireStaff, RequireManagement } from "@/components/Guards";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { ForgotPassword, ResetPassword } from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import ApplicantProfile from "@/pages/ApplicantProfile";
import Assessment from "@/pages/Assessment";
import StaffDashboard from "@/pages/staff/StaffDashboard";
import CandidateProfile from "@/pages/staff/CandidateProfile";
import AssessCandidate from "@/pages/staff/AssessCandidate";
import CalendarPage from "@/pages/staff/Calendar";
import EventDetail from "@/pages/staff/EventDetail";
import DayCandidate from "@/pages/staff/DayCandidate";
import Templates from "@/pages/staff/Templates";
import QuestionBank from "@/pages/staff/QuestionBank";
import SettingsPage from "@/pages/staff/Settings";
import BrandingPage from "@/pages/staff/Branding";
import DemoData from "@/pages/staff/DemoData";
import AuditLog from "@/pages/staff/AuditLog";
import StaffUsers from "@/pages/staff/StaffUsers";
import TrainingCamp from "@/pages/TrainingCamp";
import TrainingDay from "@/pages/TrainingDay";
import Development from "@/pages/Development";
import StaffOperators from "@/pages/staff/StaffOperators";
import OperatorProfile from "@/pages/staff/OperatorProfile";
import CompetenceReview from "@/pages/staff/CompetenceReview";
import StaffTraining from "@/pages/staff/StaffTraining";
import StaffTrainee from "@/pages/staff/StaffTrainee";
import TrainingContent from "@/pages/staff/TrainingContent";

function App() {
  useEffect(() => {
    document.title = "Lomond Operator Academy";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route element={<RequireAuth><Layout /></RequireAuth>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profile" element={<ApplicantProfile />} />
              <Route path="/assessment" element={<Assessment />} />
              <Route path="/training" element={<TrainingCamp />} />
              <Route path="/training/day/:day" element={<TrainingDay />} />
              <Route path="/development" element={<Development />} />
              <Route path="/staff" element={<RequireStaff><StaffDashboard /></RequireStaff>} />
              <Route path="/staff/candidates/:id" element={<RequireStaff><CandidateProfile /></RequireStaff>} />
              <Route path="/staff/candidates/:id/assess" element={<RequireStaff><AssessCandidate /></RequireStaff>} />
              <Route path="/staff/calendar" element={<RequireStaff><CalendarPage /></RequireStaff>} />
              <Route path="/staff/calendar/:eventId" element={<RequireStaff><EventDetail /></RequireStaff>} />
              <Route path="/staff/calendar/:eventId/candidate/:candidateId" element={<RequireStaff><DayCandidate /></RequireStaff>} />
              <Route path="/staff/training" element={<RequireStaff><StaffTraining /></RequireStaff>} />
              <Route path="/staff/training/content" element={<RequireManagement><TrainingContent /></RequireManagement>} />
              <Route path="/staff/training/:cid" element={<RequireStaff><StaffTrainee /></RequireStaff>} />
              <Route path="/staff/operators" element={<RequireStaff><StaffOperators /></RequireStaff>} />
              <Route path="/staff/operators/:id" element={<RequireStaff><OperatorProfile /></RequireStaff>} />
              <Route path="/staff/operators/:id/review" element={<RequireStaff><CompetenceReview /></RequireStaff>} />
              <Route path="/staff/templates" element={<RequireManagement><Templates /></RequireManagement>} />
              <Route path="/staff/questions" element={<RequireStaff><QuestionBank /></RequireStaff>} />
              <Route path="/staff/settings" element={<RequireStaff><SettingsPage /></RequireStaff>} />
              <Route path="/staff/branding" element={<RequireManagement><BrandingPage /></RequireManagement>} />
              <Route path="/staff/staff-users" element={<RequireManagement><StaffUsers /></RequireManagement>} />
              <Route path="/staff/demo-data" element={<RequireManagement><DemoData /></RequireManagement>} />
              <Route path="/staff/audit" element={<RequireManagement><AuditLog /></RequireManagement>} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
